import { createRouter, createWebHistory } from "vue-router";
import LandingPage from "@/views/LandingPage.vue";
import AccountPage from "@/views/AccountPage.vue";
import LoaderPage from "@/views/LoaderPage.vue";
import PlansPage from "@/views/PlansPage.vue";
import RegistrationPage from "@/views/RegistrationPage.vue";
import PaymentPage from "@/views/PaymentPage.vue";
import PrivacyPolicyPage from "@/views/PrivacyPolicyPage.vue";
import TermsOfUsePage from "@/views/TermsOfUsePage.vue";
import EmailSubscription from "@/views/EmailSubscription.vue";
import { userAPI } from "@/services/api";
import { identifyUser } from "@/analytics/mixpanel";

const routes = [
  {
    path: "/",
    name: "Landing",
    component: LandingPage,
  },
  {
    path: "/account",
    name: "Account",
    component: AccountPage,
  },
  {
    path: "/loader",
    name: "Loader",
    component: LoaderPage,
  },
  {
    path: "/plans",
    name: "Plans",
    component: PlansPage,
  },
  {
    path: "/registration",
    name: "Registration",
    component: RegistrationPage,
  },
  {
    path: "/payment",
    name: "Payment",
    component: PaymentPage,
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    component: PrivacyPolicyPage,
  },
  {
    path: "/terms-of-use",
    name: "TermsOfUse",
    component: TermsOfUsePage,
  },
  {
    path: "/email-subscription",
    name: "EmailSubscription",
    component: EmailSubscription,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Global navigation guard to prevent flash on landing page
router.beforeEach(async (to, from, next) => {
  // Only check authentication when going to landing page
  if (to.path === "/" && from.path !== "/account") {
    try {
      const response = await userAPI.getUser();
      identifyUser(response?.data);
      // User is authenticated, redirect to account
      next("/account");
    } catch (error) {
      // User is not authenticated, proceed to landing page
      next();
    }
  } else {
    // For all other routes, proceed normally
    next();
  }
});

export default router;
